module.exports = __webpack_public_path__ + "img/mail-confirm.d984561e.svg";